import Vue from 'vue/dist/vue.esm.js'

Vue.filter('labelling', function (value) {
  if (value === 'true') {
    return 'In Use'
  } else {
    return 'Approved'
  }
})

const vm = new Vue({
  el: '#app',
  data() {
    return {
      theme: 'adh', // options 'adh' or 'mhc'
      vaccines: [],
      countries: [],
      vaccinations: [],
      currentVaccination: [],
      countryData: [],
      vaccinesUsed: null,
      continent: 'All',
      currentCountry: [],
      colors: [
        '#69b443',
        '#a361c7',
        '#c5ac41',
        '#6582cb',
        '#d05a2a',
        '#49bec8',
        '#cb545e',
        '#53a570',
        '#c55d93',
        '#757d34',
        '#be7d4b',
      ],
    }
  },
  methods: {
    getData() {
      fetch('https://api.mediahack.co.za/vaccines/vaccines.php')
        .then((data) => data.json())
        .then((data) => {
          this.vaccines = data.vaccines
          this.vaccinations = data.vaccinations
          this.countries = data.countries
        })

      fetch('https://api.mediahack.co.za/vaccines/countries.php')
        .then((data) => data.json())
        .then((data) => {
          this.countryData = data
        })
    },
    changeTooltip(target) {
      let t = this.vaccines.filter((d) => d.common_name === target)
      this.currentVaccination = t[0]
    },
    changeTooltipCountries(e) {
      this.currentCountry = e
      this.currentCountry.vaccines = []

      for (let x = 1; x < 12; x++) {
        if (this.currentCountry['v' + x]) {
          this.currentCountry.vaccines.push({
            name: this.countryData.key['v' + x],
            status: this.currentCountry['v' + x + '_started'],
            date: this.currentCountry['v' + x + '_date_started'],
          })
        }
      }

      tooltipC.style.opacity = 1
    },
    hideTooltipCountries() {
      tooltipC.style.opacity = 0
    },
    moveTooltipCountries(e) {
      tooltipC.style.left = e.clientX + 20 + 'px'
      tooltipC.style.top = e.clientY + 10 + 'px'
    },
  },
  computed: {
    filteredData() {
      if (this.continent === 'All') {
        return this.countryData.countries
      } else {
        return this.countryData[this.continent]
      }
    },
  },
  mounted() {
    this.getData()
  },
})
let tooltip = document.querySelector('.tooltip-vaccines')
setTimeout(() => {
  let rows = document.querySelectorAll('.table-row')
  rows.forEach((d) => {
    d.addEventListener('mouseover', (e) => {
      tooltip.style.opacity = 1
      tooltip.style.top = e.clientY + 'px'
      tooltip.style.left = e.clientX + 20 + 'px'
    })
    d.addEventListener('mousemove', (e) => {
      tooltip.style.opacity = 1
      tooltip.style.top = e.clientY + 'px'
      //   tooltip.style.left = window.innerWidth / 2 + 'px'
      tooltip.style.left = e.clientX + 20 + 'px'
    })
    d.addEventListener('mouseout', (e) => {
      tooltip.style.opacity = 0
    })
  })
}, 1000)

let tooltipC = document.querySelector('.tooltip-countries')
